import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import ThemeToggle from "./ThemeToggle";

const Burger = ({ isDarkMode, onToggleTheme }) => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Happy Hours", path: "/happyhours" },
    { name: "HH of the Week", path: "/featured" },
    { name: "Map", path: "/map" },
    // { name: "Events", path: "/events" },
    // { name: "Specials", path: "/specials" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <>
      <div className="w-3/5 flex justify-end px-4 z-50 relative">
        <a
          href="https://www.instagram.com/jerseyshore_happyhours"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-4 text-gray-900 hover-text-light-blue transition"
        >
          <FaInstagram size={28} color="#3677cd" />
        </a>
        <button
          className="text-gray-800 hover-text-blue"
          onClick={() => setIsOpen(true)}
        >
          <Menu size={28} color="#3677cd" />
        </button>
      </div>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}
      <div
        className={`burger-menu flex flex-col fixed top-0 right-0 h-full w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${isOpen ? "translate-x-0" : "translate-x-full"
          }`}
      >
        <div className="p-4 flex justify-end">
          <button onClick={() => setIsOpen(false)}>
            <X size={24} className="text-gray-700 hover-text-blue" />
          </button>
        </div>
        <ul className="flex flex-col items-start gap-4 px-6 font-black text-base text-blue uppercase mx-4">
          {navItems.map((item) => (
            <li key={item.name} className="text-lg">
              <Link
                to={item.path}
                onClick={() => setIsOpen(false)}
                className="hover-text-light-blue transition-colors"
              >
                {item.name}
              </Link>
            </li>
          ))}
          <div className="flex flex-row gap-2">
            <a
              href="https://www.instagram.com/jerseyshore_happyhours"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-blue hover-text-light-blue transition"
            >
              <FaInstagram size={30} color="#3677cd" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61592038439351"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-blue hover-text-light-blue transition"
            >
              <FaFacebook size={28} color="#3677cd" />
            </a></div>
        </ul>
        <ThemeToggle
          isDarkMode={isDarkMode}
          onSelectTheme={(darkMode) => {
            if (darkMode !== isDarkMode) onToggleTheme();
          }}
          className="mx-6 mt-auto mb-6"
        />
      </div>
    </>
  );
};

export default Burger;
